import React from "react";
import { useTranslation } from "react-i18next";

export default function useServiceTranslation(service) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const [serviceName, setName] = React.useState(service?.title);

  React.useEffect(() => {
    const currentLangName = service?.translations[currentLang];
    if (currentLangName != null && currentLangName != "") {
      setName(currentLangName);
    } else {
      setName(service?.title);
    }
  }, [currentLang]);
  
  return serviceName;
}
